(function () {
  'use strict';

  DetectionDisplayCtrl.$inject = ['AppUtils'];

  window.angular.module('app').component('detectionDataDisplay', {
    controller: DetectionDisplayCtrl,
    controllerAs: 'ctrl',
    bindings: {
      sensor: '<',
      filterByZone: '<',
      assetName: '<',
      data: '<',
      onlyContent: '<',
      options: '<',
      feedback: '<',
      disableClick: '<',
      onLoadContent: '=',
      copyObjects: '<',
      maxHeight: '<',
      showZone: '<',
      imageMode: '<',
      showHeader: '<',
      cssClass: '<',
    },
    template:'<div class="panel panel-default rt-panel rt-panel-sm {{ctrl.cssClass}}" ng-if="!ctrl.onlyContent"><header class="panel-heading" ng-if="ctrl.showHeader"><h2><strong>{{ctrl.sensor.name}}</strong> <small>{{ctrl.assetName}}</small></h2><div class="panel-toolbars pull-right" ng-if="ctrl.image" data-html2canvas-ignore><div class="panel-toolbar"><div class="btn-group" data-toggle="buttons"><label ng-if="ctrl.histogramEnabled" ng-click="ctrl.viewMode = \'histogram\'" ng-class="{active: ctrl.viewMode === \'histogram\'}" class="btn btn-default btn-xs" title="Histogram"><i class="fas fa-chart-bar"></i></label> <button ng-click="ctrl.extendView = !ctrl.extendView" ng-disabled="!ctrl.imageLoaded" class="btn btn-default btn-xs"><i class="fas fa-external-link-alt"></i></button> <label ng-click="ctrl.viewMode = \'image\'" ng-class="{active: ctrl.viewMode === \'image\'}" class="btn btn-default btn-xs" title="Imagen"><input type="radio"> <i class="fas fa-image"></i></label> <label ng-click="ctrl.viewMode = \'raw\'" ng-class="{active: ctrl.viewMode === \'raw\'}" class="btn btn-default btn-xs" translate-attr="::{title: \'general.details\'}"><input type="radio"> <i class="fas fa-code"></i></label></div></div></div></header><div class="panel-body" ng-class="{\'with-location\': ctrl.data.location}"><div class="rt-content"><div ng-if="ctrl.content" class="full-height"><div ng-if="ctrl.viewMode=== \'image\'"><detection-image filter-by-zone="ctrl.filterByZone" sensor="ctrl.sensor" data="ctrl.data" image-mode="ctrl.imageMode" feedback="ctrl.feedback" zone="ctrl.zone" show-zone="ctrl.showZone" copy-objects="ctrl.copyObjects" max-height="ctrl.maxHeight" disable-click="ctrl.disableClick" on-load-content="ctrl.onLoadImage"></detection-image></div><div ng-if="ctrl.viewMode===\'histogram\'" style="height: 100%"><detection-histogram sensor="ctrl.sensor" filter-by-zone="ctrl.filterByZone" data="ctrl.data" zone="ctrl.zone" max-height="ctrl.maxHeight"></detection-histogram></div><div ng-if="ctrl.viewMode=== \'raw\'"><pre>{{ctrl.content | json}}</pre><div class="floating-btn" style="right: 5px" data-html2canvas-ignore><a class="btn btn-default btn-xs" ng-click="ctrl.downloadRawData()"><i class="fas fa-download fa-fw"></i></a></div></div></div><div ng-if="ctrl.data && !ctrl.data.content" class="not-data-found"><div class="small" translate>errors.NOT_DATA_FOUND</div></div><div class="center-middle" ng-if="ctrl.data && !ctrl.content"><i class="fas fa-times-rectangle fa-3x text-muted"></i></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div><div class="rt-footer"><div class="date" ng-if="ctrl.content">{{ctrl.data.from | date: "yyyy-MM-dd HH:mm:ss"}}<div ng-if="ctrl.data.location"><a target="_blank" ng-href="https://www.google.com/maps/search/?api=1&query={{ctrl.data.location.coordinates[1]}},{{ctrl.data.location.coordinates[0]}}">[ {{ctrl.data.location.coordinates[1]}}, {{ctrl.data.location.coordinates[0]}} ]</a></div></div><div class="rt-footer chart-footer" ng-if="!ctrl.data"><div class="small"><i translate>general.loading</i><i>...</i></div></div></div></div></div><div ng-if="ctrl.onlyContent" class="rt-content" style="top: 0; bottom: 0; right: 0; left: 0"><div ng-if="ctrl.content"><div ng-if="ctrl.viewMode=== \'image\' && ctrl.image"><detection-image filter-by-zone="ctrl.filterByZone" sensor="ctrl.sensor" data="ctrl.data" feedback="ctrl.feedback" image-mode="ctrl.imageMode" zone="ctrl.zone" max-height="ctrl.maxHeight" disable-click="ctrl.disableClick" on-load-content="ctrl.onLoadContent"></detection-image></div><div ng-if="ctrl.viewMode===\'histogram\'" style="height: 100%"><detection-histogram sensor="ctrl.sensor" filter-by-zone="ctrl.filterByZone" data="ctrl.data" zone="ctrl.zone" max-height="ctrl.maxHeight"></detection-histogram></div><div ng-if="ctrl.viewMode=== \'raw\'"><pre>{{ctrl.content | json}}</pre><div class="floating-btn" style="right: 5px" data-html2canvas-ignore><a class="btn btn-default btn-xs" ng-click="ctrl.downloadRawData()"><i class="fas fa-download fa-fw"></i></a></div></div></div><div class="center-middle" ng-if="ctrl.data && !ctrl.content"><i class="fas fa-times-rectangle fa-3x text-muted"></i></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div><div ng-if="ctrl.extendView" draggable class="floating-container floating-div"><div class="panel panel-default rt-panel rt-panel-md"><div class="panel-heading"><h2><strong>{{ctrl.sensor.name}}</strong> <small>{{ctrl.assetName}}</small></h2><div class="panel-toolbars pull-right"><div class="panel-toolbar"><i class="fas fa-fw fa-times" ng-click="ctrl.extendView = !ctrl.extendView"></i></div></div></div><div class="panel-body"><detection-image filter-by-zone="ctrl.filterByZone" sensor="ctrl.sensor" data="ctrl.data" feedback="ctrl.feedback" zone="ctrl.zone" copy-objects="ctrl.copyObjects" max-height="ctrl.newImgWidth" disable-click="ctrl.disableClick" on-load-content="ctrl.onloadOverlay"></detection-image><spinner show="ctrl.loading" show-logo="true" css-class="\'small light\'"></spinner></div></div></div>',
  });

  function DetectionDisplayCtrl(utils) {
    let vm = this;
    vm.viewMode = 'raw';

    vm.$onInit = function () {
      vm.extendView = false;
      vm.onLoadImage = onLoadImage;
      vm.downloadRawData = downloadRawData;
      vm.imageLoaded = false;

      vm.showHeader = typeof vm.showHeader === 'boolean' ? vm.showHeader : true;

      vm.windowSize = {
        width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
        height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
      };

      vm.windowSize.aspectRatio = vm.windowSize.width / vm.windowSize.height;

      vm.filterByZone = typeof vm.filterByZone === 'boolean' ? vm.filterByZone : false;
      if (
        vm.sensor.parameters &&
        vm.sensor.parameters.points &&
        vm.sensor.parameters.points.length > 2
      ) {
        vm.zone = vm.filterByZone ? vm.sensor.parameters.points : null;
      }

      vm.feedback = typeof vm.feedback === 'boolean' ? vm.feedback : false;
      // vm.content = vm.feedback && vm.data.feedback ? vm.data.feedback : vm.data.content;

      vm.histogramEnabled = vm.sensor.type === 'GranularityDetection';

      getImage();
    };

    vm.$onChanges = function (changes) {
      if (!vm.data) {
        return;
      }

      vm.content = vm.feedback && vm.data.feedback ? vm.data.feedback : vm.data.content;
      getImage();
      vm.viewMode = vm.image ? 'image' : 'raw';
    };

    function getImage() {
      if (typeof vm.content === 'object' && vm.content?.files) {
        vm.image = vm.content.files.gif ? vm.content.files.gif : vm.content.files.image;
      } else {
        vm.image = null;
      }
    }

    function onLoadImage(error, img) {
      if (vm.onLoadContent) {
        vm.onLoadContent(error, img);
      }

      if (error || !img) {
        return;
      }

      vm.imageLoaded = img.src.indexOf('no-image.png') == -1;

      vm.imageNaturalSize = {
        width: img.naturalWidth,
        height: img.naturalHeight,
      };

      vm.imageNaturalSize.aspectRatio = vm.imageNaturalSize.width / vm.imageNaturalSize.height;

      let maxPerc = 0.7;
      vm.newImgWidth = vm.windowSize.width * maxPerc;
      vm.newImgHeight = vm.newImgWidth / vm.imageNaturalSize.aspectRatio;
    }

    function downloadRawData() {
      const data = vm.data.content;
      let ts = vm.data.from;
      if (ts.getTime) {
        ts = ts.getTime();
      }

      const sensorName = utils.removeAccents(vm.sensor.name).replace(/ /g, '_');
      const filename = sensorName + '_' + ts + '.json';
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'text/json;charset=utf-8' });

      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
})();
